<template>
  <div class="cta-wrapper">
    <Buttonv2
      class="cta-button"
      :class="{'white': variant === 'white'}"
      variant="link"
      @click="$emit('click')"
    >
      <span>
        {{ $t("Make a free quiz") }}
      </span>
      <aha-icon
        class="cta-icon"
        name="open-new-window"
      />
    </Buttonv2>
  </div>
</template>

<script>
import Buttonv2 from '../UI/Buttonv2.vue'

export default {
  components: {
    Buttonv2,
  },
  props: {
    variant: {
      type: String,
      default: 'dark',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.cta-wrapper {
  width: 100%;
  max-width: 400px;
  margin: 16px auto;
  text-align: center; // always center cta button
}
.cta-button {
  color: #0A0A0A;
  font-size: 16px;
  opacity: 0.7;
  &.white {
    color: inherit;
  }
  &:hover {
    color: $primary;
  }
}
</style>
